<template>
  <div class='index'>
    <div class='index-header'>
      <avatar :size='44' :src='avatar' :bg-color='avatarBg' />
      <div class='header-right'>
        <h3>Hi！{{ userInfo.name }}</h3>
        <span>{{ userInfo.departPath }}</span>
      </div>
    </div>
    <div class='index-body'>
      <info-panel title='我的应用'>
        <my-app :data="appList" />
      </info-panel>
      <info-panel title='待办明细'>
        <to-do :data="todoData" @load="loadData" />
      </info-panel>
      <info-panel title='常用功能'>
        <commonly-used />
      </info-panel>
    </div>
    <!--提示-->
    <tip-modal v-if="tips.display" ref="TipModal" :isVisible="tips.visible" :info="tips.info" @close="modalClose"/>
  </div>
</template>
<script>
import { getUserDepartInfo, getTodo } from '@/api/home'
import { mapGetters } from 'vuex'
export default {
  name: 'AdminIndex',
  components: {
    TipModal: () => import('@/components/tipModal'),
    Avatar: () => import('@/components/Avatar'),
    InfoPanel: () => import('./components/InfoPanel.vue'),
    MyApp: () => import('./components/MyApp.vue'),
    ToDo: () => import('./components/ToDo.vue'),
    CommonlyUsed: () => import('./components/CommonlyUsed.vue')
  },
  data() {
    return {
      tips: {
        display: false,
        visible: false,
        info: {
          title: '',
          detail: ''
        },
        close: null
      },
      userInfo: {
        name: '',
        departPath: ''
      },
      appList: [],
      todoData: {
        tabs: [],
        list: [],
        totalSize: 0,
        loading: false
      }
    }
  },
  computed: {
    ...mapGetters(['avatar', 'avatarBg'])
  },
  provide() {
    return {
      // 提示
      toast: this.toast.bind(this),
      // 确认提示
      confirm: this.confirm.bind(this),
      // 弹窗
      popup: function (com, data) {
        return new Promise((resolve, reject) => {
          this.$refs[com].show(resolve, reject, data)
        })
      }
    }
  },
  created() {
    getUserDepartInfo().then(({ code, data, msg }) => {
      if (code === '0') {
        const { name, departPath } = data
        this.userInfo.name = name
        this.userInfo.departPath = departPath
      } else {
        this.$message.error(msg)
      }
    })
  },
  mounted() {
    this.$nextTick(() => {
      this.$loading.hide()
    })
  },
  methods: {
    toast(res, flags = 0) {
      return new Promise((resolve, reject) => {
        if (res.code === '0') {
          if (flags === 1) {
            this.$message.success(res.msg)
          }
          resolve(res)
        } else {
          this.$message.error(res.msg)
          reject(new Error(res.msg))
        }
      })
    },
    confirm(msg, title = '提示') {
      return new Promise((resolve, reject) => {
        this.tips.close = data => {
          this.tips.visible = false
          if (data === false) {
            reject(new Error('取消'))
          } else {
            resolve(data)
          }
          // 延迟销毁，保存弹窗隐藏动画
          setTimeout(() => { this.tips.display = false }, 500)
        }
        this.tips.display = true
        this.$nextTick(() => {
          this.syncMounted(() => [this.$refs.TipModal]).then(() => {
            const { info } = this.tips
            info.title = title
            info.detail = msg
            this.tips.visible = true
          })
        })
      })
    },
    modalClose(data) {
      this.tips.close(data)
    },
    async loadData (data) {
      const { todoData } = this
      todoData.loading = true
      const res = await getTodo(data)
      todoData.loading = false
      await this.toast(res)
      const { subsystemToDoVoList, toDoDeailVoList, totalSize } = res.data
      todoData.list = toDoDeailVoList.map(item => {
        const [path, queryStr] = item.jumpLink.split('?')
        const query = {
          timestamp: new Date().getTime()
        }
        if (queryStr) {
          const searchParams = new URLSearchParams(queryStr)
          searchParams.forEach((value, key) => {
            query[key] = value
          })
        }
        item.path = path
        item.query = query
        return item
      })
      todoData.totalSize = totalSize
      const tabs = []
      let allTotal = 0
      this.appList = subsystemToDoVoList.map(({ code, name, total, logoUrl, countList, internetSubSystem, internetSubSystemUrl }) => {
        allTotal += total
        if (total > 0) {
          tabs.push({ code, name, total })
        }
        return { code, name, total, logoUrl, countList: countList.filter(ele => ele.count > 0), internetSubSystem, internetSubSystemUrl }
      })
      tabs.unshift({
        code: '',
        name: '全部明细',
        total: allTotal
      })
      todoData.tabs = tabs
    },
    /**
     * 所有节点都有值，才进行调用
     * @param {Function}} getNodes - 返回节点数组
     */
    async syncMounted(getNodes) {
      // 计数器
      let count = 0
      // 定时时间
      const time = 100
      // 方法超时时间
      const timeout = 5000
      // 是否加载完成
      const isMounted = () => {
        const nodes = getNodes()
        if (Array.isArray(nodes)) {
          return !nodes.some(ele => ele == null)
        } else {
          throw new Error('syncMounted参数方法返回值必须为数组')
        }
      }
      return new Promise((resolve, reject) => {
        // 初始化判断
        if (isMounted()) {
          return resolve()
        }
        // 定时判断
        const timer = setInterval(() => {
          if (isMounted()) {
            clearInterval(timer)
            return resolve()
          }
          count += time
          // 如果大于指定秒数，则中止
          if (count > timeout) {
            clearInterval(timer)
            reject(new Error('syncMounted方法超时'))
          }
        }, time)
      })
    }
  }
}
</script>
<style lang='less' scoped>
.index {
  height: 100%;
  border-color: #f0f0f0;
  border-style: solid;
  @top-width: 8px;
  @left-width: 40px;
  border-top-width: @top-width;
  border-bottom-width: @top-width;
  border-left-width: @left-width;
  border-right-width: @left-width;
  display: flex;
  flex-direction: column;
  .index-header {
    padding: 16px;
    border-bottom: 1px solid rgba(159, 162, 169, 0.2);
    display: flex;
    background: url(./images/header-bg.png) no-repeat right center / 1000px;
    .header-right {
      margin-left: 16px;
      font-family: PingFangSC-Regular;
      h3 {
        font-size: 18px;
        color: #000000;
      }
      span {
        font-size: 12px;
        color: rgba(51, 51, 51, 0.6);
      }
    }
  }
  .index-body{
    overflow: auto;
    padding: 16px;
  }
}
</style>
